<template>
  <div class="sidebar">
    <sidebar-header />
    <sidebar-menu />
    <sidebar-footer />
  </div>
</template>
<script setup lang="ts">
import SidebarFooter from './SidebarFooter.vue';
import SidebarHeader from './SidebarHeader.vue';
import SidebarMenu from './SidebarMenu.vue';

</script>
<style lang="scss">
.sidebar {
  min-height: 0;
  background-color: var(--pidz-blue);
  padding: 0 0 32px 0;
  color: white;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 700;

  .menu-item {
    cursor: pointer;
    padding: 8px 32px;
    display: flex;
    align-items: center;
    width: 100%;
    color: inherit;
    font-weight: 700;
    text-decoration: inherit;

    &.active {
      background-color: #4079b5;
      border-left: 4px solid var(--pidz-blue-background);
      padding-left: 28px;
    }

    &:hover {
      background-color: #4079b5;
      transition: background-color 0.2s ease-in-out;
    }
  }
  @media only screen and (min-width: map.get($screen-sizes, 'extra-large')) {
    overflow-y: auto;
    scrollbar-gutter: stable;
    scrollbar-width: thin;
  }
}
</style>
